// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BpSWj","question":"styles_question__jFfuW","inputVisibleButton":"styles_inputVisibleButton__ZO7_v","note":"styles_note__2z9iK"};